import { Link } from "react-router-dom";
const Home = () => {
    const currentURL = window.location.origin;
    const backgroundImage = `${currentURL}/cats.webp`;
    return (
        <div className="h-screen w-screen relative">
            {/* Sección de fondo con imagen y degradado */}
            <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-fixed"
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                }}
            >
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-900"></div>
            </div>

            {/* Contenido centrado */}
            <div className="relative h-full flex flex-col justify-center items-center  text-center">
                <h1 className="text-5xl font-bold mb-6">
                    Explora los eventos de ciudad de gatos
                </h1>
                <Link
                    to="/eventos" // Asegúrate de tener la ruta correcta definida
                    className="mt-4 bg-yellow-cdg hover:bg-yellow-600  py-3 px-6 rounded-lg text-lg text-black"
                >
                    Ver Eventos
                </Link>
            </div>
        </div>
    );
};

export default Home;
